import Contact from "@/model/interface/Contact";

export function getContactDisplayName(contact?: Contact | null): string | null {
  if (!contact) return null;
  const first = contact.aliasFirstName || contact.firstName || "";
  const last = contact.aliasLastName || contact.lastName || "";
  const name = `${first} ${last}`.trim();
  if (name) return name;
  if (contact.phones?.length) return contact.phones[0].phoneNumber || null;
  return null;
}

export function getInitialsFromFullName(name?: string | null): string {
  if (!name) {
    return "?";
  }
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return getInitials(parts[0], parts.length > 1 ? parts[parts.length - 1] : undefined);
}

export function getInitials(firstName?: string, lastName?: string): string {
  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }
  if (firstName) {
    return firstName.slice(0, 2).toUpperCase();
  }
  if (lastName) {
    return lastName.slice(0, 2).toUpperCase();
  }
  return "?";
}
